import React from 'react'
import PropTypes from 'prop-types'

export default function DieselTracksLineUp({ section }) {
  function renderCustomLink(href, children) {
    const isExternalLink = href.includes('http')
    return (
      /* eslint-disable react/jsx-no-target-blank */
      <a
        href={href}
        className={`diesel-tracks-font-primary nts-button diesel-tracks__spotify-cta ${!isExternalLink ? 'nts-app' : ''}`}
        target={isExternalLink ? '_blank' : '_self'}
        rel={isExternalLink ? 'noopener noreferrer': ''}>
        {children}
      </a>
      /* eslint-enable react/jsx-no-target-blank */
    )
  }

  return (
    <section
      id="DieselTracksLineUp"
      className="diesel-tracks__section diesel-tracks__line-up"
      key={section.strapi_component}>
      <div className="diesel-tracks__line-up-wrapper">
        <div className="diesel-tracks__heading-container">
          {section.header_logo &&
            <div className="diesel-tracks__line-up-header-logo-container">
              <img
                className="diesel-tracks__line-up-header-logo"
                src={section.header_logo.url}
                alt="Header Logo" />
            </div>
          }

          <h2 className="diesel-tracks-font-primary diesel-tracks-heading diesel-tracks__line-up-heading">
            {section.heading}
          </h2>
          {section.subheading &&
            <span className="diesel-tracks-font-primary diesel-tracks__line-up-subheading">
              {section.subheading}
            </span>
          }
        </div>

        {section.description &&
          <div
            className="diesel-tracks-font-primary diesel-tracks__paragraph diesel-tracks__line-up-description"
            dangerouslySetInnerHTML={{ __html: section.description.replace(/\n/g, '<br />') }} />
        }

        <div className="diesel-tracks__line-up-artists">
          {!!section.artists_left_column.length &&
            <ul className="nts-list diesel-tracks__line-up-artists-list">
              {section.artists_left_column.map((artist, index) => {
                return (
                  <li
                    className="diesel-tracks__line-up-artist"
                    key={index}>
                    <h3 className="diesel-tracks-font-primary diesel-tracks-heading diesel-tracks__line-up-artist-name">
                      {artist.name}
                    </h3>
                  </li>
                )
              })}
            </ul>
          }

          {!!section.artists_right_column.length &&
            <ul className="nts-list diesel-tracks__line-up-artists-list">
              {section.artists_right_column.map((artist, index) => {
                return (
                  <li
                    className="diesel-tracks__line-up-artist"
                    key={index}>
                    <h3 className="diesel-tracks-font-primary diesel-tracks-heading diesel-tracks__line-up-artist-name">
                      {artist.name}
                    </h3>
                  </li>
                )
              })}
            </ul>
          }
        </div>

        {section.cta && section.cta.link_url && section.cta.label &&
          <div className="diesel-tracks__spotify-cta-group">
            {renderCustomLink(section.cta.link_url, section.cta.label)}
          </div>
        }
      </div>
    </section>
  )
}

DieselTracksLineUp.propTypes = {
  section: PropTypes.object,
}
